module.exports = __webpack_public_path__ + "img/horizontal-logo-white.5d56551c.svg";